import { render, staticRenderFns } from "./OrdenSucursalDialog.vue?vue&type=template&id=6b7f3c4a&"
import script from "./OrdenSucursalDialog.vue?vue&type=script&lang=js&"
export * from "./OrdenSucursalDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports